import { signOut } from "aws-amplify/auth";

export interface SignOutRedirectConfig {
  clientId: string;
  domain: string;
  redirectUri: string;
}

function getHostedUiOrigin(domain: string) {
  return domain.startsWith("http://") || domain.startsWith("https://")
    ? domain
    : `https://${domain}`;
}

/**
 * Signs out across all AssetWatch apps by revoking tokens server-side via
 * Cognito GlobalSignOut. When Hosted UI details are provided, this also clears
 * the Cognito session cookie and redirects the browser back to the app.
 */
export async function signOutEverywhere(
  redirectConfig?: SignOutRedirectConfig,
): Promise<void> {
  try {
    await signOut({ global: true });
  } finally {
    if (
      typeof window === "undefined" ||
      !redirectConfig?.clientId ||
      !redirectConfig.domain ||
      !redirectConfig.redirectUri
    ) {
      // Preserve the existing best-effort sign-out behavior when no redirect is configured.
      // eslint-disable-next-line no-unsafe-finally
      return;
    }

    const logoutUrl = new URL(
      "/logout",
      getHostedUiOrigin(redirectConfig.domain),
    );
    logoutUrl.searchParams.set("client_id", redirectConfig.clientId);
    logoutUrl.searchParams.set("logout_uri", redirectConfig.redirectUri);
    window.location.assign(logoutUrl.toString());
  }
}
